<ng-container *transloco="let t">
  <main class="input">
    <header class="header">
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.alarms:hubLocation') }}</mat-label>
        <input
          type="text"
          matInput
          [placeholder]="t('inspection.fields.alarms:hubLocation')"
          drawableField="alarms:hubLocation"
          [drawableFieldTitle]="t('inspection.fields.alarms:hubLocation')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="alarmCheck.hubLocation"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.alarms:hubModel') }}</mat-label>
        <input
          type="text"
          matInput
          [placeholder]="t('inspection.fields.alarms:hubModel')"
          drawableField="alarms:hubModel"
          [drawableFieldTitle]="t('inspection.fields.alarms:hubModel')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="alarmCheck.hubModel"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.alarms:serialNumber') }}</mat-label>
        <input
          type="text"
          matInput
          [placeholder]="t('inspection.fields.alarms:serialNumber')"
          drawableField="alarms:serialNumber"
          [drawableFieldTitle]="t('inspection.fields.alarms:serialNumber')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="alarmCheck.serialNumber"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{ t('inspection.fields.alarms:dialer') }}</mat-label>
        <input
          type="text"
          matInput
          [placeholder]="t('inspection.fields.alarms:dialer')"
          drawableField="alarms:dialer"
          [drawableFieldTitle]="t('inspection.fields.alarms:dialer')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="alarmCheck.dialer"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
    </header>

    <section>
      <table
        mat-table
        class="mat-elevation-z4 boundary"
        cdkDropList
        [dataSource]="alarmCheck.alarms"
        [cdkDropListData]="alarmCheck.alarms"
        [cdkDropListDisabled]="readonly"
        (cdkDropListDropped)="drop($event)"
      >
        <ng-container matColumnDef="drag">
          <th mat-header-cell *matHeaderCellDef></th>
          <td
            mat-cell
            *matCellDef="let element"
            cdkDrag
            cdkDragRootElement="tr"
            cdkDragLockAxis="y"
            cdkDragBoundary=".boundary"
            [cdkDragData]="element"
          >
            <div cdkDragHandle class="drag-handle">
              <authority-labs-drag-icon></authority-labs-drag-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="accessory">
          <th mat-header-cell *matHeaderCellDef>
            {{ t('inspection.fields.alarms:accessoryType') }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field>
              <textarea
                matInput
                name="accessory"
                cdkTextareaAutosize
                [(ngModel)]="element.accessory"
                [printPreview]="printPreview"
                [readonly]="readonly || printPreview"
                (input)="onChange()"
              ></textarea>
            </mat-form-field></td
        ></ng-container>

        <ng-container matColumnDef="nameAndLocation">
          <th mat-header-cell *matHeaderCellDef>
            {{ t('inspection.fields.alarms:locationNickname') }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field>
              <textarea
                matInput
                name="nameAndLocation"
                cdkTextareaAutosize
                [(ngModel)]="element.nameAndLocation"
                [printPreview]="printPreview"
                [readonly]="readonly || printPreview"
                (input)="onChange()"
              ></textarea>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>
            {{ t('inspection.fields.alarms:accessoryAddress') }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field>
              <textarea
                matInput
                name="address"
                cdkTextareaAutosize
                [(ngModel)]="element.address"
                [printPreview]="printPreview"
                [readonly]="readonly || printPreview"
                (input)="onChange()"
              ></textarea>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-stroked-button color="primary" (click)="addAlarm()">
              {{ t('add') }}
            </button>
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-stroked-button
              color="primary"
              (click)="removeAlarm(element)"
            >
              {{ t('inspection.fields.plans:remove') }}
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </section>

    <section>
      <div style="padding-bottom: 10px">
        <mat-checkbox
          *ngIf="!printPreview"
          matSuffix
          [(ngModel)]="alarmCheck.addToReport"
          [disabled]="readonly"
          color="primary"
          (change)="onChange()"
        >
          {{ t('inspection.fields.alarms:attachToCertificate') }}
        </mat-checkbox>
      </div>
      <div>
        <mat-radio-group
          aria-label="Select an option"
          [(ngModel)]="alarmCheck.isPassed"
          [disabled]="readonly || printPreview"
          (change)="onChange()"
        >
          <mat-radio-button [value]="true">{{
            t('inspection.fields.alarms:suitable')
          }}</mat-radio-button>
          <mat-radio-button [value]="false" color="warn">{{
            t('inspection.fields.alarms:notSuitable')
          }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <authority-labs-check-notes
        [notes]="alarmCheck.notes"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [type]="alarmCheck.title"
        (dataChange)="onChange()"
      ></authority-labs-check-notes>
    </section>
  </main>
</ng-container>
